export default __webpack_public_path__ + "static/media/save-upto-fifty.1d965c0f.png";